import React from 'react';
import { CtaButton } from './CtaButton';
import { CTA_SECUNDARIO, PRECIO_LARGO } from '../data/content';
export function FinalSection() {
  return <section className="w-full bg-petrol py-11 text-white sm:py-14 lg:py-16" aria-labelledby="cierre" data-id="element-27" data-mp="3c2c7iz6a5dnm">
      <div className="mx-auto w-full max-w-2xl px-5 text-center sm:px-8" data-id="element-28" data-mp="2y5goqf0887ud">
        <h2 id="cierre" className="font-display text-2xl font-extrabold leading-[1.12] tracking-tight sm:text-[2.4rem]" data-id="element-29" data-mp="3314g9126ld31">
          La próxima vez que te pidan un informe, que no sea una sorpresa.
        </h2>

        <div className="mx-auto mt-6 max-w-md" data-id="element-30" data-mp="2t63z5mhz0mo3">
          <CtaButton label={CTA_SECUNDARIO} variant="light" data-id="element-31" data-mp="2fdwbck8o061j" />
          <p className="mt-3 font-mono text-base font-bold" data-id="element-32" data-mp="2je6ocguvjwpw">{PRECIO_LARGO}</p>
          <p className="mt-0.5 text-[13px] text-white/70" data-id="element-33" data-mp="2jc3pd7bqut91">Pago único · Acceso inmediato</p>
        </div>
      </div>
    </section>;
}